import {ReloadButton,} from '@flexinet/ui-components';

import {Box,} from '@mantine/core';

import {useActivityLogs} from '../hooks/useActivityLogs.ts';

export const ReloadRecordsButton = () => {

    const {fetchRecords} = useActivityLogs();
    return (
        <Box mx='s'>
            <ReloadButton onClick={() => fetchRecords()}/>
        </Box>
    );
};

